'use strict';
angular.module('productManageMentWebsiteModule', [
    'productManageMentWebsiteRouterModule',
    'productManageMentWebsiteChannelModule',
    'productManageMentWebsiteColumnModule',
    'productManageMentWebsiteColumnDistributionModule',
    //'productManageMentWebsiteDistributeConfigModule',
    'productManageMentWebsiteFragmentationModule',
    'productManageMentWebsiteManuscriptSourceModule',
    'productManageMentWebsiteParameterConfigModule',
    'manageProSiteModule',
    'productManageMentWebsiteTemplateModule',
    'productManageMentWebsiteServiceModule',
    //  'productManageMentWebsiteServiceModule',
     "editManuSourceModule",
    'proManaMentWebsiteFootModule',
    'websiteWatermarkMgrModule'
     ]).
controller('websiteController', ['$scope', '$state', 'trsHttpService', 'modalDialog', '$modal', '$stateParams', 'localStorageService', 'productMangageMentWebsiteService', function($scope, $state, trsHttpService, modalDialog, $modal, $stateParams, localStorageService, productMangageMentWebsiteService) {
    //$state.go("manageconfig.productmanage.website.site");
}]);